import React from 'react'
import UserAvatar from './UserAvatar'
import { Conversation } from '../../types/messages'
import { formatDate } from '../../utils/formatHelpers'

interface ConversationItemProps {
  conversation: Conversation
  isSelected: boolean
  onClick: () => void
}

const ConversationItem = ({ conversation, isSelected, onClick }: ConversationItemProps) => {
  return (
    <div
      className={`
        tw-flex tw-items-center tw-p-3 tw-bg-white
        tw-rounded-lg tw-border hover:tw-bg-gray-50
        tw-transition-all tw-duration-150 tw-ease-in-out tw-cursor-pointer
        focus-visible:tw-ring-2 focus-visible:tw-ring-sky-500 focus-visible:tw-outline-none
        ${isSelected
                ? 'tw-border-sky-500 tw-shadow-md'
                : 'tw-border-gray-200 hover:tw-border-gray-300 tw-shadow-sm hover:tw-shadow'
            }
      `}
      onClick={onClick}
      onKeyDown={(e) => e.key === 'Enter' && onClick()}
      tabIndex={0}
    >
      <div className='tw-mr-3 md:tw-mr-4 tw-flex-shrink-0'>
        <UserAvatar
          name={conversation.participantName}
          unreadCount={conversation.unreadCount}
          id={conversation.participantId}
          size={40}
        />
      </div>
      <div className='tw-flex-grow tw-overflow-hidden'>
        <div className='tw-flex tw-justify-between tw-items-start'>
          <h5 className='tw-text-sm tw-font-semibold tw-text-gray-800 tw-truncate'>
            {conversation.participantName}
          </h5>
          <small className='tw-text-xs tw-text-gray-400 tw-flex-shrink-0 tw-ml-2 tw-whitespace-nowrap'>
            {formatDate(conversation.lastMessageTime)}
          </small>
        </div>
        <p className='tw-text-xs tw-text-gray-500 tw-truncate tw-mt-0.5'>
          {conversation.hasAttachment && (
            <i
              className='fa fa-paperclip tw-text-gray-400 tw-mr-1'
              style={{ fontSize: '0.9em' }}
              aria-label='Załącznik'
            />
          )}
          {conversation.lastMessage || <span className='tw-italic'>Brak wiadomości</span>}
        </p>
      </div>
    </div>
  )
}

export default ConversationItem
